export const productList = {
    fields: [{
        title: "Type",
        type: "select",
        require: true,
        defaultvalue: "Pharmacutical",
        options: [{
            label: "MOHAP Registration",
            value: 'pharmacutical'

        },
        {
            label: "Municipality Registration",
            value: 'cosmatics'

        }
        ]
    },
    {
        title: "Source",
        type: "select",
        require: true,
        defaultvalue: "CSV File",
        options: [{
            label: "PDF File",
            value: 'pdf',
            key:'.pdf'

        },
        {
            label: "CSV File",
            value: 'csv',
            key:'.csv'

        },
        {
            label: "Excel File",
            value: 'xlsx',
            key:'.xlsx'

        }

        ]
    },
    {
        title: "Supplier ID",
        type: "upload",
        secondTile: "Upload Product File",
        require: true,
    }
    ,
    {
        title: "Fetch",
        type: "",
        secondTile: "Upload Product File",
    }
    ]
}